import BuildConfig from '@/environment';
import i18n from '@/plugins/i18n';

export const getAlertsV2NavTabs = () => [
  {
    name: i18n.global.t('open-alerts'),
    path: 'generatedV2',
    fullPath: '/alertsV2/generatedV2',
    hide: false,
  },
  {
    name: i18n.global.t('sm.configuredAlerts'),
    path: 'configuredV2',
    fullPath: '/alertsV2/configuredV2',
    hide: false,
  },
  {
    name: i18n.global.t('tag-grouping'),
    path: 'tagGroupingV2',
    fullPath: '/alertsV2/tagGroupingV2',
    hide: !BuildConfig.VUE_APP_ALERT_V2_TAG_GROUP_ENABLE,
    isBeta: false,
    resourceGroup: 'notification', // To support RBACV2 permissions
  },
  {
    name: i18n.global.t('alert.externalTagGrouping'),
    path: 'extTagGroupingV2',
    fullPath: '/alertsV2/extTagGroupingV2',
    hide: !BuildConfig.VUE_APP_ALERT_V2_EXT_TAG_GROUP_ENABLE,
    resourceGroup: 'notification',
  },
];

const alertsV2 = {
  key: 'alertsV2',
  name: i18n.global.t('alerts'),
  icon: 'alert',
  navTabs: getAlertsV2NavTabs(),
};
export default alertsV2;
